import { render } from "./SpacedRow.vue?vue&type=template&id=6118a4fe&scoped=true"
const script = {}

import "./SpacedRow.vue?vue&type=style&index=0&id=6118a4fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6118a4fe"]])

export default __exports__